import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';
import Beach from '../../img/beach.jpg';
import Bakery from '../../img/bakery.jpg';
import G80 from '../../img/g80.jpg';
import Landscape from '../../img/landscape.jpg';
import Car from '../../img/lambo.jpg';
import House from '../../img/real_estate.jpg';

const featuredPhotos = [
  {
    id: 'feat_1',
    image: Beach.src,
    alt: 'Coastal landscape with vibrant colors',
  },
  {
    id: 'feat_2',
    image: Bakery.src,
    alt: 'Bakery storefront with warm lighting and inviting atmosphere',
  },
  {
    id: 'feat_3',
    image: G80.src,
    alt: 'BMW G80 M3 captured in dynamic motion with blurred background for speed effect',
  },
  {
    id: 'feat_4',
    image: Landscape.src,
    alt: 'Scenic bridge over river surrounded by lush greenery and dramatic sky',
  },
  {
    id: 'feat_5',
    image: House.src,
    alt: 'Real estate property with modern architecture and well-manicured landscaping',
  },
  {
    id: 'feat_6',
    image: Car.src,
    alt: 'McLaren in motion with blurred background for dynamic effect, showcasing sleek design and vibrant color',
  },
];

export default function FeaturedWork() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 reveal">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 tracking-tight">
            Featured Work
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A curated selection of our finest photography showcasing diverse styles and moments
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 reveal delay-200">
          {/* Large Featured (spans 2 columns) */}
          <Link
            href="/gallery"
            className="md:col-span-2 lg:row-span-2 group relative overflow-hidden rounded-2xl aspect-[4/3] md:aspect-auto"
          >
            <AppImage
              src={featuredPhotos?.[0]?.image}
              alt={featuredPhotos?.[0]?.alt}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </Link>

          {/* Regular Grid Items */}
          {featuredPhotos?.slice(1)?.map((photo) => {
            if (photo.id === 'feat_2' || photo.id === 'feat_3') {
              return (
                <Link
                  key={photo?.id}
                  href="/gallery"
                  className="group relative overflow-hidden rounded-2xl"
                >
                  <AppImage
                    src={photo?.image}
                    alt={photo?.alt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </Link>
              );
            } else {
              return (
                <Link
                  key={photo?.id}
                  href="/gallery"
                  className="group relative overflow-hidden rounded-2xl aspect-square"
                >
                  <AppImage
                    src={photo?.image}
                    alt={photo?.alt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </Link>
              );
            }
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 reveal delay-300">
          <Link
            href="/gallery"
            className="inline-flex items-center gap-2 px-8 py-4 border border-white/20 rounded-lg font-medium text-white hover:bg-white hover:text-background transition-all duration-300"
          >
            View Full Portfolio
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
